<template>
  <v-container
    class="ma-0 pa-0"
  >
    <v-row
      class="ma-0 pa-0"
    >
      <!--結果表示欄-->
      <v-col
        cols="6"
        class="ma-0 pa-1"
      >
        <v-card
          class="ma-0 pa-0 overflow-y-auto"
          style="height:87vh;"
        >
          <v-tabs
            v-model="outputTabs"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
            fixed
            class="fixed-bar"
          >
            <v-tabs-slider />

            <v-tab :href="'#output-type-1'">
              連続単語
            </v-tab>

            <v-tab :href="'#output-type-2'">
              単語
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="outputTabs">
            <v-tab-item
              :value="'output-type-1'"
            >
              <!-- 連続品詞 -->
              <v-list
                v-for="item in $store.state.partAnalysis.dspPosList.multiple"
                :key="item"
                class="ma-1 pa-0"
                max-height="70"
                v-text="item"
              />
            </v-tab-item>

            <v-tab-item
              :value="'output-type-2'"
            >
              <!-- 単独品詞 -->
              <v-list
                v-for="item in $store.state.partAnalysis.dspPosList.single"
                :key="item"
                class="ma-1 pa-0"
                max-height="70"
                v-text="item"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
      <!--ここまでー結果表示欄-->

      <!--選択エリア-->
      <v-col
        cols="6"
        class="ma-0 pa-1"
      >
        <v-card
          class="ma-0 pa-0 overflow-y-auto"
          style="height:87vh;"
        >
          <v-tabs
            v-model="editTabs"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
            fixed-tabs
            class="fixed-bar"
          >
            <v-tabs-slider />
            <v-tab :href="'#edit-type-1'">
              品詞選択
            </v-tab>
            <v-tab :href="'#edit-type-2'">
              編集・設定
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="editTabs">
            <v-tab-item :value="'edit-type-1'">
              <v-row class="ma-0 pa-1 pt-2">
                <v-col class="ma-0 pa-0">
                  <v-btn
                    color="primary"
                    small
                    outlined
                    class="ma-1 pa-2"
                    @click="$store.commit('partAnalysis/checkReset')"
                  >
                    <v-icon>
                      mdi-checkbox-blank-off-outline
                    </v-icon>
                    <span>Clear All</span>
                  </v-btn>
                </v-col>
              </v-row>

              <v-divider class="ma-1 pa-0" />

              <v-row
                class="ma-0 pa-1"
              >
                <v-col
                  class="ma-0 pa-0 pt-1"
                  cols="3"
                  style="float:left"
                >
                  <v-btn
                    color="primary"
                    small
                    outlined
                    @click="$store.commit('partAnalysis/searchAct')"
                  >
                    <span>実行</span>
                  </v-btn>
                </v-col>

                <v-col
                  class="ma-0 pa-0"
                  cols="9"
                  style="float:right"
                >
                  <v-text-field
                    v-model="$store.state.partAnalysis.searchText"
                    dense
                    hide-details
                    single-line
                    label="単語入力欄（1単語）"
                  />
                </v-col>
                <v-col
                  class="ma-0 pa-0"
                  cols="12"
                >
                  <v-btn-toggle
                    v-model="$store.state.partAnalysis.isSearchMode"
                    class="ma-0 pa-2"
                    color="primary"
                  >
                    <v-btn
                      x-small
                      outlined
                      block
                    >
                      <span>単語限定</span>
                    </v-btn>
                    <v-btn
                      x-small
                      outlined
                      block
                    >
                      <span>単語任意</span>
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>

              <v-divider class="ma-1 pa-0" />

              <v-col
                class="ma-0 pa-1"
                cols="5"
                style="float:left"
              >
                <v-chip
                  color="blue"
                  outlined
                  small
                >
                  一般品詞
                </v-chip>

                <v-checkbox
                  v-for="i in $store.state.partAnalysis.dspPosCheckBox.pos1"
                  :key="i"
                  v-model="$store.state.partAnalysis.watchPos1Check"
                  :label="i"
                  :value="i"
                  class="ma-0 pa-0"
                  hide-details
                  menu-props="auto"
                />
              </v-col>

              <v-col
                class="ma-0 pa-1"
                cols="7"
                style="float: right"
              >
                <v-chip
                  color="blue"
                  outlined
                  small
                >
                  詳細品詞
                </v-chip>
                <v-checkbox
                  v-for="i in $store.state.partAnalysis.dspPosCheckBox.pos2"
                  :key="i"
                  v-model="$store.state.partAnalysis.watchPos2Check"
                  :label="i"
                  :value="i"
                  dense
                  class="ma-0 pa-0"
                  hide-details
                  menu-props="auto"
                />
              </v-col>
            </v-tab-item>

            <v-tab-item
              :value="'edit-type-2'"
              class="ma-0 pa-2"
            >
              <v-chip
                color="blue"
                outlined
                class="ma-2 pa-4"
              >
                設定
              </v-chip>
              <v-switch
                v-model="$store.state.partAnalysis.isHiSpeed"
                hide-details="false"
                class="ma-0 pa-1"
                :label="`${$store.state.partAnalysis.isHiSpeed ? '高速モード（色なし）' : '通常モード（色あり）' }`"
              />
              <v-switch
                v-model="$store.state.partAnalysis.isNumberSort"
                hide-details="false"
                class="ma-0 pa-1"
                :label="`${$store.state.partAnalysis.isNumberSort ? '出現数ソートモード': '文字ソートモード' }`"
              />
              <v-switch
                v-model="$store.state.partAnalysis.isZenAnalyse"
                hide-details="false"
                class="ma-0 pa-1"
                :label="`${$store.state.partAnalysis.isZenAnalyse ? '全角解析モード※推奨': '通常解析モード'}`"
              />
              <!-- <v-btn-toggle
                v-model="$store.state.partAnalysis.isZenAnalyse"
                class="mt-5 pa-0"
                color="primary"
                dense
              >
                <v-btn
                  small
                  outlined
                >
                  <span>通常解析</span>
                </v-btn>
                <v-btn
                  small
                  outlined
                >
                  <span>全角変換後解析※推奨</span>
                </v-btn>
            </v-btn-toggle> -->
              <v-chip
                color="blue"
                outlined
                class="ma-2 pa-4"
              >
                変換
              </v-chip>
              <v-select
                v-model="$store.state.partAnalysis.convertSelected.zenkaku"
                class="ma-0 pa-1"
                :items="$store.state.partAnalysis.convertList"
                item-text="label"
                item-value="value"
                menu-props="auto"
                label="全角変換対象"
                hide-details
                single-line
              />
              <v-btn
                block
                small
                outlined
                class="mb-3 pa-0"
                color="primary"
                @click="$store.commit('partAnalysis/convertZenkaku')"
              >
                全角変換実行
              </v-btn>
              <v-select
                v-model="$store.state.partAnalysis.convertSelected.hankaku"
                class="ma-0 pa-1"
                :items="$store.state.partAnalysis.convertList"
                item-text="label"
                item-value="value"
                menu-props="auto"
                label="半角変換対象"
                hide-details
                single-line
              />
              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="$store.commit('partAnalysis/convertHankaku')"
              >
                半角変換実行
              </v-btn>
              <v-text-field
                v-model="$store.state.partAnalysis.replaceText.search"
                dense
                hide-details
                single-line
                label="置換対象"
              />
              <v-text-field
                v-model="$store.state.partAnalysis.replaceText.replace"
                class="pb-1"
                dense
                hide-details
                single-line
                label="置換文字"
              />
              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="$store.commit('partAnalysis/replaceAll')"
              >
                置換実行
              </v-btn>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      outputTabs: null,
      editTabs: null,
    }),

    computed: {
      watchPos1Check () { return this.$store.state.partAnalysis.watchPos1Check },
      watchPos2Check () { return this.$store.state.partAnalysis.watchPos2Check },
    },

    watch: {
      watchPos1Check () { this.$store.commit('partAnalysis/watchPos1Check') },
      watchPos2Check () { this.$store.commit('partAnalysis/watchPos2Check') },
    },
  }
</script>

<style>
.fixed-bar {
    position: sticky;
    position: -webkit-sticky; /* for Safari */
    top: 0em;
    z-index: 1;
}
.backgroundClass {
  background-color: aqua;
}
</style>
